<template>
  <v-card>
    <v-card-title class="text_primary mb-0 pb-0">
      {{ page_title }}

      <v-spacer></v-spacer>

      <!-- <v-btn
            class="mr-2 white--text"
            color="#5087e6"
            @click="openCheckWebRuleDialog"
        >
          檢查網址規則
        </v-btn> -->

      <v-btn
        :disabled="quota_setting.quantity >= quota_setting.limit"
        class="white--text"
        color="#5087e6"
        @click="showDialog"
      >
        <v-icon v-if="quota_setting.quantity >= quota_setting.limit" small class="mr-2">mdi-lock</v-icon>
        新增
      </v-btn>
    </v-card-title>
    <div
      v-if="quota_setting.quantity >= quota_setting.limit"
      class="d-flex justify-end mt-1 pr-3"
      style="color: red; font-size: 14px"
    >
      已達使用上限，請加購或刪除現有實驗。
    </div>
    <!--- usedQuantity先隨便寫個數字當example，之後接Charles Api再用computed替換掉 --->
    <UsedQuotaInfo
      v-if="quota_setting.is_show"
      :service="'可建立實驗數'"
      :usage="quota_setting.quantity"
      :limit="quota_setting.limit"
      :is_show_percentbar="quota_setting.is_show_percentbar"
    />

    <v-tabs v-model="tab" show-arrows center-active color="primary">
      <v-tab v-for="item in experiments_tab_items" :key="item.id" :value="item.title" @click="changeTab(item)">
        {{ item.title }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" color="blue darken-4">
      <v-card elevation="0">
        <v-card-title v-if="check_rule_chip_items.length > 0" style="height: auto; width: auto">
          已選檢查網址：
        </v-card-title>

        <v-chip-group
          v-if="check_rule_chip_items.length > 0"
          column
          active-class="primary--text"
          style="margin-left: 20px; width: 100%"
        >
          <v-chip
            v-for="(chip, index) in check_rule_chip_items"
            :key="chip.id"
            close
            close-icon="mdi-close"
            class="white--text multi-line-chip"
            style="height: 100%"
            color="primary"
            @click:close="removeChip(index)"
          >
            {{
              `檢查網址：${chip.url}\n只檢查已發布實驗：${chip.release_only ? '是' : '否'}\n實驗時間：${
                chip.target_time ? chip.target_time : '未選擇'
              }`
            }}
          </v-chip>
        </v-chip-group>

        <!-- <keep-alive>
        
        <v-expansion-panels>

          <v-expansion-panel @click="renderChart()" ref="expanded">

            <v-expansion-panel-header>
              實驗排程圖
            </v-expansion-panel-header>

            <v-expansion-panel-content>

              
                <div class="d-flex justify-space-around">
                  <v-menu
                      v-model="displayDatePickerStart"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                      v-if="items.length"
                      @change="initChart"
                  >
                      <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="chartStartAt"
                              label="開始日期"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              color="#5087e6"
                          ></v-text-field>
                      </template>

                      <v-date-picker
                          v-model="chartStartAt"
                          @input="displayDatePickerStart = false"
                          locale="zh-cn"
                          header-color="#5087e6"
                          color="#5087e6"
                      ></v-date-picker>
                  </v-menu>

                  <v-menu
                      v-model="displayDatePickerEnd"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                      v-if="items.length"
                      @change="initChart"
                  >
                      <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="chartEndAt"
                              label="結束日期"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              color="#5087e6"
                          ></v-text-field>
                      </template>

                      <v-date-picker
                          v-model="chartEndAt"
                          @input="displayDatePickerEnd = false"
                          locale="zh-cn"
                          header-color="#5087e6"
                          color="#5087e6"
                      ></v-date-picker>
                  </v-menu>
                </div>
              
              <GanttChart
                :chartData="data"
                :chartLabels="labels"
                :chartTitle="`行銷圖卡任務管理`"
                :startAt="chartStartAt"
                :endAt="chartEndAt"
              />

            </v-expansion-panel-content>

          </v-expansion-panel>

        </v-expansion-panels>
    </keep-alive> -->
        <v-card-title>
          <v-row>
            <v-col cols="12" lg="8" md="12" xs="12">
              <v-card-text class="d-flex align-center justify-end pl-0 ml-0 pt-0 pr-0 pb-0">
                <v-text-field
                  v-model="search"
                  dense
                  outlined
                  class="pt-0"
                  label="輸入關鍵字搜索(名稱/網址)"
                  single-line
                  hide-details
                  color="primary"
                  @keypress.enter="searchKeyword(search)"
                ></v-text-field>
                <v-btn class="ml-3 btn_action btn_action_bg_linear" @click="searchKeyword(search)">
                  <v-icon> mdi-magnify </v-icon>
                </v-btn>
              </v-card-text>
            </v-col>
            <v-col cols="12" lg="4" md="12" xs="12">
              <v-card-text class="d-flex align-center justify-end pa-0">
                <p class="mb-0 pb-0 mr-3">顯示</p>
                <v-select
                  v-model="selected_per_page"
                  style="max-width: 7em"
                  outlined
                  return-object
                  :items="per_page_items"
                  item-value="value"
                  item-text="name"
                  hide-details
                  dense
                  @change="chagePerPage(selected_per_page)"
                >
                </v-select>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-title>
        <v-data-table
          :loading="loading"
          :loading-text="loading_text"
          :no-data-text="'尚未有實驗。'"
          :no-results-text="'找不到相符實驗。'"
          :headers="table_header[mode]"
          :items="items"
          hide-default-footer
          :items-per-page="selected_per_page.value"
        >
          <template #[`item.name`]="{ item }">
            <div class="row-pointer truncate">
              <a class="text-decoration-none" target="_blank" :href="getExpURL(item.id)">{{ item.name }}</a>
            </div>
          </template>
          <template #[`item.views`]="{ item }">
            <div>
              {{ item.views ? $utils.formatNumberWithCommas(item.views) : 0 }}
            </div>
          </template>

          <template #[`item.url`]="{ item }">
            <div class="d-flex align-center justify-space-between">
              <div class="truncate mr-3" style="cursor: text">
                {{ decodeURIComponent(decodeURIComponent(item.url)) }}
              </div>
              <v-icon small @click="openURL(item)"> mdi-open-in-new </v-icon>
            </div>
          </template>

          <template #[`item.start_at`]="{ item }">
            {{ item.start_at.slice(0, -3) }}
          </template>

          <template #[`item.end_at`]="{ item }">
            {{ item.end_at.slice(0, -3) }}
          </template>

          <template #[`item.status`]="{ item }">
            <v-chip v-if="item.status === 'running'" label text-color="white" color="release"> 發布 </v-chip>
            <v-chip v-else-if="item.status === 'disable'" label text-color="white" color="end"> 結束 </v-chip>
            <v-chip v-else text-color="white" color="draft" label> 草稿 </v-chip>
          </template>

          <template #[`item.actions`]="{ item, attrs, on }">
            <v-menu offset-y bottom right v-bind="attrs" v-on="on">
              <template #activator="{ on }">
                <v-tooltip bottom>
                  <template #activator="{ on: tooltipOn }">
                    <v-btn icon v-on="{ ...on, ...tooltipOn }">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <span>點擊查看更多</span>
                </v-tooltip>
              </template>

              <v-list style="padding: 0px" dense>
                <v-list-item @click="viewInfo(item)">
                  <v-icon left> mdi-file-edit-outline </v-icon>
                  <v-list-item-title>編輯</v-list-item-title>
                </v-list-item>

                <!-- 如果是預設容器就不要讓使用者把它刪掉，把刪除按鈕禁用 -->
                <v-list-item @click="deleteItem(item)">
                  <v-icon left> mdi-trash-can-outline </v-icon>
                  <v-list-item-title>刪除</v-list-item-title>
                </v-list-item>

                <v-list-item @click="copyExperience(item)">
                  <v-icon left> mdi-content-duplicate </v-icon>
                  <v-list-item-title>複製</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
    </v-tabs-items>

    <div class="text-center mt-5">
      <Pagination v-if="page_setting.is_show" :setting="page_setting" @changePage="changePageCallback" />
    </div>

    <!-- 檢查網頁規則彈窗 Start -->
    <DialogForm
      v-if="is_show_check_rule_dialog"
      :dialog-setting="check_rule_dialog_setting"
      @submit="checkWebRule"
      @close="closeDialog"
    />
    <!-- 檢查網頁規則彈窗 End -->

    <!-- 新增實驗彈窗 Start -->
    <!-- <DialogForm
      v-if="is_show_new_dialog"
      :dialogSetting="dialog_setting"
      @submit="addExperiment"
      @close="closeDialog"
    /> -->
    <ExperienceModal
      v-if="is_show_new_dialog"
      :text_setting="text_setting"
      :init_setting="experiment_setting"
      @close="is_show_new_dialog = false"
      @submit="addExperimentV2"
    ></ExperienceModal>
    <!-- 新增實驗彈窗 End -->

    <!-- 更新實驗彈窗 Start -->
    <DialogForm
      v-if="is_open_update_dialog"
      :dialog-setting="open_update_experience_dialog_setting"
      @submit="updateExperience"
      @close="closeDialog"
    />
    <!-- 更新實驗彈窗 End -->

    <LoadingOverlay :is-loading="isLoading" />
  </v-card>
</template>

<script>
// 子元件
import DialogForm from '@/components/Utils/DialogForm.vue'
import LoadingOverlay from '@/components/Utils/LoadingOverlay.vue'
// import CustomDataTable from "./ChildComponent/CustomDataTable.vue"
import UsedQuotaInfo from '@/components/Utils/UsedQuotaInfo.vue'
// import GanttChart from "@/components/Utils/GanttChart.vue"

import Pagination from '@/components/Utils/Pagination.vue'
// import Description from "./ChildComponent/Description.vue"
// import Settings from "./ChildComponent/Settings/Settings.vue"
// import EvaluteAndGoals from "./ChildComponent/EvaluteAndGoals.vue"
import ExperienceModal from './ChildComponent/ExperienceModal.vue'

import {
  apiGetExperiments,
  apiCreateExperiment,
  apiCreateExperimentWithData,
  apiDeleteExperiment,
  // apiGetNotify,
  apiPatchNotifyBind,
  apiPatchExperienceRelease,
  apiPatchExperienceDisable,
  apiCheckMatchExperients,
  apiCopyExperience,
} from '@/api/optimize.js'

import { apiPatchRegisterGroup, apiGetNotify } from '@/api/notify.js'

import {
  // apiGetAnalysisReport,
  apiGetAnalysisReportSummary,
} from '@/api/analysis.js'

import { apiGetSubscriptionInfoWithData } from '@/api/organize.js'

export default {
  // props: ['register_group'],
  name: 'ExperimentList',
  components: {
    Pagination,
    DialogForm,
    LoadingOverlay,
    // CustomDataTable,
    UsedQuotaInfo,
    ExperienceModal,
    // GanttChart
    // Description,
    // Settings,
    // EvaluteAndGoals
  },
  provide() {
    return {
      parentMethod: this.copyToClipboard,
      snackbar: this.snackbar,
    }
  },
  data: function () {
    return {
      // 甘特圖所需參數
      data: [],
      labels: [],
      displayDatePickerStart: false,
      displayDatePickerEnd: false,
      chartStartAt: '',
      chartEndAt: '',

      // 檢查網址規則的模式下，有符合的都push進這些Array
      check_rule_chip_items: [],
      items_is_match: [],

      is_show_check_rule_dialog: false,

      is_open_update_dialog: false,

      receiver_name_items: null,

      receiver_name: null,

      token: '',

      e6: 1,

      childKey: 0,

      register_group: {
        register_group_token_expired: null,
        register_group_token: null,
      },

      is_open_notify_dialog: false,

      body_script:
        '&lt;!-- Google Tag Manager (noscript) --&gt;&lt;script&gt;example&lt;/script&gt;&lt;!-- End Google Tag Manager (noscript) --&gt;',

      head_script: 'example',

      snackbar: false,

      // isOpenAbtestScript: false,

      validate_text: '尚未驗證。發布實驗前，請確認代碼已正確安裝 (必須)。',

      actions_item: [{ title: 'Click Me' }, { title: 'Click Me' }, { title: 'Click Me' }, { title: 'Click Me 2' }],

      experiments_tab_items: [
        {
          id: 'all',
          title: '全部',
          color: '#FFB74D',
          index: 0,
        },
        {
          id: 'draft',
          title: '草稿',
          color: '#FFB74D',
          index: 1,
        },
        {
          id: 'release',
          title: '發布',
          color: '#4FC3F7',
          index: 2,
        },
        {
          id: 'end',
          title: '結束(歷史資料)',
          color: '#4DD0E1',
          index: 3,
        },
      ],

      tab: null,

      //搜尋框文字
      search: '',

      // 綁定該實驗的缺貨通知
      is_bind_product_by_experience: false,

      // loading遮罩
      isLoading: false,

      // 頁面名稱
      page_title: '實驗',

      // items
      items: [],

      breadcrumb_items: [
        {
          text: '',
          disabled: false,
          to: '/container',
          exact: true,
        },
        {
          text: '實驗列表',
          disabled: true,
          to: '',
          exact: true,
        },
      ],
      table_header: {
        all: [
          { text: '狀態', value: 'status', sortable: false },
          // { text: '符合', value: 'is_match', sortable: false,},
          { text: '名稱', value: 'name', sortable: false },
          { text: '網址', value: 'url', sortable: false },
          { text: '開始時間', value: 'start_at', sortable: false },
          { text: '結束時間', value: 'end_at', sortable: false },
          // { text: '狀態', value: 'enable', sortable: false,},
          // { text: '缺貨提醒', value: 'need_detect', sortable: false },

          // { text: '代碼安裝狀態', value: 'validate_code_install', sortable: false },
          // { text: '結束實驗', value: 'enable', sortable: false },
          { text: '', value: 'actions', sortable: false },
        ],
        draft: [
          { text: '狀態', value: 'status', sortable: false },
          // { text: '符合', value: 'is_match', sortable: false,},
          { text: '名稱', value: 'name', sortable: false },
          { text: '網址', value: 'url', sortable: false },
          { text: '開始時間', value: 'start_at', sortable: false },
          { text: '結束時間', value: 'end_at', sortable: false },
          // { text: '狀態', value: 'enable', sortable: false,},
          // { text: '缺貨提醒', value: 'need_detect', sortable: false },
          // { text: '代碼安裝狀態', value: 'validate_code_install', sortable: false },
          // { text: '結束實驗', value: 'enable', sortable: false },
          { text: '', value: 'actions', sortable: false },
        ],
        running: [
          { text: '狀態', value: 'status', sortable: false },
          // { text: '符合', value: 'is_match', sortable: false,},
          { text: '名稱', value: 'name', sortable: false },
          { text: '網址', value: 'url', sortable: false },
          { text: '工作階段', value: 'views', sortable: true, align: 'right' },
          { text: '開始時間', value: 'start_at', sortable: false },
          { text: '結束時間', value: 'end_at', sortable: false },
          // { text: '狀態', value: 'enable', sortable: false,},
          // { text: '缺貨提醒', value: 'need_detect', sortable: false },
          // { text: '代碼安裝狀態', value: 'validate_code_install', sortable: false },
          // { text: '結束實驗', value: 'enable', sortable: false },
          { text: '', value: 'actions', sortable: false },
        ],
        disable: [
          // { text: '平台名稱', value: 'platform', sortable: false,},
          { text: '狀態', value: 'status', sortable: false },
          { text: '名稱', value: 'name', sortable: false },
          { text: '網址', value: 'url', sortable: false },
          { text: '工作階段', value: 'views', sortable: true, align: 'right' },
          { text: '開始時間', value: 'start_at', sortable: false },
          { text: '結束時間', value: 'end_at', sortable: false },
          // { text: '狀態', value: 'enable', sortable: false,},
          // { text: '缺貨提醒', value: 'need_detect', sortable: false },
          // { text: '實驗狀態', value: 'release', sortable: false },
          // { text: '結束實驗', value: 'enable', sortable: false },
          { text: '', value: 'actions', sortable: false },
        ],
      },

      // 草稿、發布實驗的tab
      headers: [
        // { text: '符合', value: 'is_match', sortable: false,},
        { text: '實驗名稱', value: 'name', sortable: false },
        { text: '網址', value: 'url', sortable: false },
        { text: '開始時間', value: 'start_at', sortable: false },
        { text: '結束時間', value: 'end_at', sortable: false },
        // { text: '狀態', value: 'enable', sortable: false,},
        // { text: '缺貨提醒', value: 'need_detect', sortable: false },
        { text: '實驗狀態', value: 'is_release', sortable: false },
        // { text: '代碼安裝狀態', value: 'validate_code_install', sortable: false },
        // { text: '結束實驗', value: 'enable', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ],

      // 結束(歷史資料)的tab
      tab_2_headers: [
        // { text: '平台名稱', value: 'platform', sortable: false,},
        { text: '實驗名稱', value: 'name', sortable: false },
        { text: '網址', value: 'url', sortable: false },
        { text: '開始時間', value: 'start_at', sortable: false },
        { text: '結束時間', value: 'end_at', sortable: false },
        // { text: '狀態', value: 'enable', sortable: false,},
        // { text: '缺貨提醒', value: 'need_detect', sortable: false },
        // { text: '實驗狀態', value: 'release', sortable: false },
        // { text: '結束實驗', value: 'enable', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ],

      btn: {
        view: '檢視',
        delete: '刪除',
        notify: '缺貨提醒',
      },
      dialog_setting: {
        title: '新增實驗',
        fields: [
          {
            id: 'name',
            label: '實驗名稱',
            value: null,
            hint: '家電產品A',
            type: 'text',
          },
          {
            id: 'url',
            label: '網址',
            value: null,
            hint: 'https://your_website.com/product',
            type: 'text',
          },
          // {
          //   "id": "memo",
          //   "label": "實驗說明",
          //   "value": null,
          //   "hint": "寫下對小組有幫助的說明。",
          //   "type": "text",
          //   "is_show": false,
          // },
          {
            type: null,
            is_show: false,
            label: '開始時間',
            grids: [
              {
                id: 'start_at',
                label: '開始時間',
                value: null,
                type: 'date',
                is_show: false,
                hint: '日期',
              },
              {
                id: 'start_at_time',
                label: '',
                value: null,
                type: 'time',
                is_show: false,
                hint: '時間',
              },
            ],
          },
          {
            type: null,
            is_show: false,
            label: '結束時間',
            grids: [
              {
                id: 'end_at',
                label: '結束時間',
                value: null,
                hint: '日期',
                type: 'date',
                is_show: false,
              },
              {
                id: 'end_at_time',
                label: '',
                value: null,
                type: 'time',
                is_show: false,
                hint: '時間',
              },
            ],
          },
          // {
          //   "type": null,
          //   "is_show": false,
          //   "label": "活動開始時間",
          //   "grids" : [
          //       {
          //         "id": "campaign_start_at",
          //         "label": "活動開始時間",
          //         "value": null,
          //         "hint": "日期",
          //         "type": "date",
          //         "is_show": false,
          //       },
          //       {
          //         "id": "campaign_start_at_time",
          //         "label": "",
          //         "value": null,
          //         "type": "time",
          //         "is_show": false,
          //         "hint": "時間",
          //       }
          //   ]
          // },
          // {
          //   "type": null,
          //   "is_show": false,
          //   "label": "活動結束時間",
          //   "grids" : [
          //       {
          //         "id": "campaign_end_at",
          //         "label": "活動結束時間",
          //         "value": null,
          //         "hint": "日期",
          //         "type": "date",
          //         "is_show": false,
          //       },
          //       {
          //         "id": "campaign_end_at_time",
          //         "label": "",
          //         "value": null,
          //         "type": "time",
          //         "is_show": false,
          //         "hint": "時間",
          //       }
          //   ]
          // }
        ],
        submit_text: '新增',
        submit_callback: 'submit',
        close_callback: 'close',
        views: null,
      },
      bind_product_dialog_setting: {
        title: '缺貨通知綁定',
        fields: [
          {
            id: 'notify_id',
            label: '綁定line bot，請選擇接收者名稱。',
            value: null,
            hint: 'Test Optimize',
            type: 'select',
            is_show: false,
            receiver_items: null,
          },
        ],
        submit_text: '綁定',
        submit_callback: 'submit',
        close_callback: 'close',
        views: null,
      },
      open_notify_dialog_setting: {
        title: '開啟缺貨通知',
        fields: [
          {
            id: 'platform',
            value: null,
            label: '平台名稱',
            hint: 'cyberbiz、shopline、91app',
            type: 'text',
            is_show: false,
            receiver_items: null,
          },
        ],
        submit_text: '開啟',
        submit_callback: 'submit',
        close_callback: 'close',
        views: null,
      },
      // 因為要並排顯示，多了grids這個key，在Dialogform.vue裡搜尋v-if="item.grids!==null"這裡會顯示更改時間的元件
      open_update_experience_dialog_setting: {
        title: '更新實驗',
        fields: [
          {
            id: 'name',
            label: '實驗名稱',
            value: null,
            hint: '家電產品A',
            type: 'text',
          },
          {
            id: 'url',
            label: '網址',
            value: null,
            hint: 'https://your_website.com/product',
            type: 'text',
          },
          {
            id: 'memo',
            label: '實驗說明',
            value: null,
            hint: '寫下對小組有幫助的說明。',
            type: 'text',
            is_show: false,
          },
          {
            type: null,
            is_show: false,
            label: '開始時間',
            grids: [
              {
                id: 'start_at',
                label: '開始時間',
                value: null,
                type: 'date',
                is_show: false,
                hint: '日期',
              },
              {
                id: 'start_at_time',
                label: '',
                value: null,
                type: 'time',
                is_show: false,
                hint: '時間',
              },
            ],
          },
          {
            type: null,
            is_show: false,
            label: '結束時間',
            grids: [
              {
                id: 'end_at',
                label: '結束時間',
                value: null,
                hint: '日期',
                type: 'date',
                is_show: false,
              },
              {
                id: 'end_at_time',
                label: '',
                value: null,
                type: 'time',
                is_show: false,
                hint: '時間',
              },
            ],
          },
          // {
          //   "type": null,
          //   "is_show": false,
          //   "label": "活動開始時間",
          //   "grids" : [
          //       {
          //         "id": "campaign_start_at",
          //         "label": "活動開始時間",
          //         "value": null,
          //         "hint": "日期",
          //         "type": "date",
          //         "is_show": false,
          //       },
          //       {
          //         "id": "campaign_start_at_time",
          //         "label": "",
          //         "value": null,
          //         "type": "time",
          //         "is_show": false,
          //         "hint": "時間",
          //       }
          //   ]
          // },
          // {
          //   "type": null,
          //   "is_show": false,
          //   "label": "活動結束時間",
          //   "grids" : [
          //       {
          //         "id": "campaign_end_at",
          //         "label": "活動結束時間",
          //         "value": null,
          //         "hint": "日期",
          //         "type": "date",
          //         "is_show": false,
          //       },
          //       {
          //         "id": "campaign_end_at_time",
          //         "label": "",
          //         "value": null,
          //         "type": "time",
          //         "is_show": false,
          //         "hint": "時間",
          //       }
          //   ]
          // }
        ],
        submit_text: '更新',
        submit_callback: 'submit',
        close_callback: 'close',
        views: null,
      },
      check_rule_dialog_setting: {
        title: '檢查網頁規則',
        fields: [
          {
            id: 'url',
            label: '網址',
            hint: '例如: https://www.example.com/test/?test=true#test',
            type: 'text',
            value: null,
          },
          {
            type: null,
            is_show: false,
            label: '實驗時間',
            grids: [
              {
                id: 'target_date',
                label: '實驗時間',
                value: null,
                hint: '日期',
                type: 'date',
                is_show: false,
              },
              {
                id: 'target_time',
                label: '',
                value: null,
                type: 'time',
                is_show: false,
                hint: '時間',
              },
            ],
          },
          {
            id: 'release_only',
            label: '只檢查已發布的實驗',
            hint: '例如: https://www.example.com/test/?test=true#test',
            type: 'checkbox',
            value: false,
          },
        ],
        views: null,
        headers: null,
        submit_text: '檢查',
        submit_callback: 'submit',
        close_callback: 'close',
      },
      is_show_new_dialog: false,
      org_id: '',
      notify: false,
      get_notify_items: null,
      setting: {
        token: 'yooooo',
      },
      mapping_backend_field: {
        開始時間: 'start_at',
        結束時間: 'end_at',
        活動開始時間: 'campaign_start_at',
        活動結束時間: 'campaign_end_at',
      },

      // 是否開啟檢查規則模式
      check_rule_mode: false,

      color: ['#FFB74D', '#4FC3F7', '#4DD0E1', '#64B5F6'],

      reportResultSummary: null,

      quota_setting: {
        display_name: '',
        name: {
          end: '總實驗數',
        },
        is_show: false,
        quantity: 0,
        limit: 0,
        is_show_percentbar: true,
      },

      tab_mapper: {
        all: 0,
        draft: 1,
        running: 2,
        disable: 3,
        0: 'all',
        1: 'draft',
        2: 'running',
        3: 'disable',
      },

      mode: 'disable',

      page_setting: {
        is_show: false,
        selected_page: 1,
        total_page: 10,
        total_visible: 5,
      },
      selected_per_page: {
        name: '48筆',
        value: 48,
      },
      per_page_items: [
        {
          name: '10筆',
          value: 10,
        },
        {
          name: '24筆',
          value: 24,
        },
        {
          name: '48筆',
          value: 48,
        },
        {
          name: '100筆',
          value: 100,
        },
      ],
      experiment_setting: {},
      text_setting: {
        title: '新增實驗',
        submit_text: '新增',
        cancel_text: '取消',
      },
      loading: false,
      loading_text: '載入中',
    }
  },
  computed: {
    getServiceName() {
      return this.tab === 1 ? '可發布實驗數' : '保留歷史實驗數'
    },
    filter_status_drafts() {
      return this.check_rule_mode
        ? this.items_is_match.filter((item) => {
            return item.enable === true && item.is_release === false
          })
        : this.items.filter((item) => {
            return item.enable === true && item.is_release === false
          })
    },
    filter_status_release() {
      return this.check_rule_mode
        ? this.items_is_match.filter((item) => {
            return item.enable === true && item.is_release === true
          })
        : this.items.filter((item) => {
            return item.enable === true && item.is_release === true
          })
    },
    filter_status_close() {
      return this.check_rule_mode
        ? this.items_is_match.filter((item) => {
            return item.enable === false
          })
        : this.items.filter((item) => {
            return item.enable === false
          })
    },
    is_have_token() {
      return this.register_group.register_group_token !== null
    },
  },
  watch: {
    tab: {
      handler: function (newVal, oldVal) {
        console.log(newVal)
        console.log(oldVal)
        // console.log(this.$refs.expanded);
        // console.log(this.$refs.expanded.isActive);
        // if (oldVal !== newVal) {
        //   this.$refs.expanded.isActive = false
        // }
        if (this.$refs.expanded && this.$refs.expanded.isActive) {
          this.initChart(
            this.$mixins.getQueryStringValue(window.location.href, 'start_at'),
            this.$mixins.getQueryStringValue(window.location.href, 'end_at')
          )
        }
      },
    },
    get_notify_items(newVal, oldVal) {
      console.log('oldVal', oldVal)
      console.log('newVal', newVal)
      if (oldVal !== newVal && newVal !== null) {
        this.receiver_name_items = this.get_notify_items.map((item) => item.receiver_name)
      }
    },
    items(newVal, oldVal) {
      console.log(newVal)
      console.log(oldVal)
    },
    chartStartAt: {
      handler: async function (newVal, oldVal) {
        console.log(oldVal)
        console.log(newVal)
        if (newVal && oldVal) {
          this.reportResultSummary = await null
          await this.initChart(newVal, null)
          const newUrl = this.$mixins.updateQueryString(window.location.href, 'start_at', newVal)
          window.history.pushState({ path: newUrl }, '', newUrl)
        }
      },
    },
    chartEndAt: {
      handler: async function (newVal, oldVal) {
        console.log(oldVal)
        console.log(newVal)
        if (newVal && oldVal) {
          this.reportResultSummary = await null
          await this.initChart(null, newVal)
          console.log(window.location.href)
          const newUrl = this.$mixins.updateQueryString(window.location.href, 'end_at', newVal)
          window.history.pushState({ path: newUrl }, '', newUrl)
        }
      },
    },
  },
  created: async function () {
    this.loading = true
    try {
      let mode = this.$route.query.mode
      console.log('mode:', mode)
      if (mode && this.tab_mapper[mode] !== undefined) {
        console.log('mode1')
        this.mode = mode
        this.tab = this.tab_mapper[mode]
      } else {
        console.log('mode2')
        this.tab = this.tab_mapper[this.mode]
      }

      let url_query = this.$route.query
      // page idx
      if (url_query.page && !isNaN(parseInt(url_query.page))) {
        this.page_setting.selected_page = parseInt(url_query.page)
      }
      // 筆數
      if (url_query.limit && !isNaN(parseInt(url_query.limit))) {
        this.selected_per_page.name = `${parseInt(url_query.limit)}筆`
        this.selected_per_page.value = parseInt(url_query.limit)
        console.log('this.selected_per_page', this.selected_per_page)
      }
      if (url_query.keyword) {
        this.search = url_query.keyword
      }

      this.isLoading = true
      this.items = await this.getExperiments()
      this.page_setting.is_show = true

      await this.getExpQuota()
    } catch (e) {
      console.log(e)
      this.$root.vtoast.show({ message: e.name + ': ' + e.message, color: 'error' })
    } finally {
      this.isLoading = false
    }
    this.loading = false
  },
  mounted: function () {},
  methods: {
    async renderChart() {
      // if (!this.$refs.expanded.isActive) return
      this.$refs.expanded.isActive = true
      this.$refs.expanded.nextIsActive = true
      this.$refs.expanded.isActive = true
      this.$refs.expanded.nextIsActive = true
      await this.initChart()
      await this.handleUrl()
      // if (this.reportResultSummary === null) {
      //   console.log('%c11111', 'background-color:orange')
      //   this.reportResultSummary = await this.getReportResultSummary(this.chartStartAt, this.chartEndAt)
      // }
      // console.log(`%c爽拉`,this.reportResultSummary,"color: red");
    },
    handleUrl() {
      const isHaveQueryString = this.$mixins.checkQueryString(window.location.href)
      if (!isHaveQueryString) {
        console.log('123', this.chartStartAt)
        const newUrl = this.$mixins.addQueryStrings(window.location.href, {
          start_at: this.chartStartAt,
          end_at: this.chartEndAt,
        })
        console.log(newUrl)
        window.history.pushState({ path: newUrl }, '', newUrl)
      } else {
        console.log('456')
        console.log(window.location.href)
        this.chartStartAt = this.$mixins.getQueryStringValue(window.location.href, 'start_at')
        this.chartEndAt = this.$mixins.getQueryStringValue(window.location.href, 'end_at')
      }
    },
    async getReportResultSummary(start_at, end_at) {
      console.log(start_at)
      console.log(end_at)
      // let params = {
      //     "start": "string",
      //     "end": "string",
      //     "org": "nineder",
      //     "container": "雪倫團"
      // }
      let result
      result = await apiGetAnalysisReportSummary(
        this.$route.params.org_id,
        this.$route.params.container_id,
        String(start_at),
        String(end_at)
      )
        .then(async (resp) => {
          console.log(resp)
          let {
            data: { data },
          } = resp
          console.log(data)
          return data
        })
        .catch((error) => {
          console.log(error)
          return null
        })
      return result
    },
    // getReportResult() {
    //   let result
    //   result = apiGetAnalysisReport(this.$route.params.org_id, 194)
    //     .then( resp => {
    //       console.log(resp);
    //       let { data } = resp;
    //       console.log(data);
    //       return data
    //     })
    //     .catch( error => {
    //       console.log(error);
    //       return null
    //     })
    //   return result
    // },
    async initChart(userSetStart, userSetEnd) {
      if (!this.items.length) {
        return
      }

      const foundItem = this.experiments_tab_items.find((item) => item.index === this.tab)

      if (foundItem) {
        // 如果this.data裡面有項目代表是true，那麼就會執行右邊的程式，js短路求值
        this.data.length && this.data.shift()

        this.data.push({
          label: foundItem.title,
          data: [],
          fill: true,
          borderColor: foundItem.color,
          tension: 0.5,
          backgroundColor: foundItem.color,
          spanGaps: true,
          borderWidth: 2,
          borderSkipped: false,
          borderRadius: 5,
          barPercentage: 0.5,
        })
      }

      const isHaveQueryString = this.$mixins.checkQueryString(window.location.href)

      console.log(this.data)
      if (userSetStart) {
        console.log('1')
        this.chartStartAt = userSetStart
        const newUrl = this.$mixins.updateQueryString(window.location.href, 'start_at', userSetStart)
        window.history.pushState({ path: newUrl }, '', newUrl)
      } else {
        console.log('2')
        this.chartStartAt = isHaveQueryString
          ? this.$mixins.getQueryStringValue(window.location.href, 'start_at')
          : await this.getDay(-21)
        const newUrl = this.$mixins.updateQueryString(window.location.href, 'start_at', this.chartStartAt)
        window.history.pushState({ path: newUrl }, '', newUrl)
      }

      if (userSetEnd) {
        console.log('3')
        this.chartEndAt = userSetEnd
        const newUrl = this.$mixins.updateQueryString(window.location.href, 'end_at', userSetEnd)
        window.history.pushState({ path: newUrl }, '', newUrl)
      } else {
        console.log('4')
        this.chartEndAt = isHaveQueryString
          ? this.$mixins.getQueryStringValue(window.location.href, 'end_at')
          : await this.getDay(7)
        const newUrl = this.$mixins.updateQueryString(window.location.href, 'end_at', this.chartEndAt)
        window.history.pushState({ path: newUrl }, '', newUrl)
      }
      // this.chartStartAt = userSetStart ? userSetStart : await this.getDay(-21)
      // console.log(this.chartStartAt);
      // this.chartEndAt = userSetEnd ? userSetEnd : await this.getDay(7)
      console.log(this.chartEndAt)
      console.log(this.items)
      // let analysisResult = this.getReportResultSummary === null ?  : this.getReportResultSummary
      console.log(this.reportResultSummary)
      let analysisResult
      if (this.reportResultSummary === null) {
        console.log('%c11111', 'background-color:orange')
        analysisResult = await this.getReportResultSummary(this.chartStartAt, this.chartEndAt)
      } else {
        // alert('2')
        analysisResult = this.reportResultSummary
      }
      console.log(analysisResult)
      let newGetAnalysisItems = this.items.map((item) => {
        return { ...item, analysisResult: analysisResult?.[item.id] }
      })
      console.log(newGetAnalysisItems)

      // 分3種實驗狀態的資料
      this.data = this.data
        .map((item) => {
          if (item.label === '草稿') {
            item.data = newGetAnalysisItems
              .filter((item) => item.enable === true && item.is_release === false)
              .map((item) => {
                if (
                  this.isWithinRange(
                    item['start_at'].split(' ')[0],
                    item['end_at'].split(' ')[0],
                    this.chartStartAt,
                    this.chartEndAt
                  )
                ) {
                  return {
                    x: [item['start_at'].split(' ')[0], item['end_at'].split(' ')[0]],
                    y: item['name'],
                    customAnalysisResult: item['analysisResult'],
                  }
                }
              })
              .filter((item) => item !== undefined)
          }

          if (item.label === '發布') {
            item.data = newGetAnalysisItems
              .filter((item) => item.enable === true && item.is_release === true)
              .map((item) => {
                if (
                  this.isWithinRange(
                    item['start_at'].split(' ')[0],
                    item['end_at'].split(' ')[0],
                    this.chartStartAt,
                    this.chartEndAt
                  )
                ) {
                  return {
                    x: [item['start_at'].split(' ')[0], item['end_at'].split(' ')[0]],
                    y: item['name'],
                    customAnalysisResult: item['analysisResult'],
                  }
                }
              })
              .filter((item) => item !== undefined)
          }

          if (item.label === '結束(歷史資料)') {
            item.data = newGetAnalysisItems
              .filter((item) => item.enable === false)
              .map((item) => {
                if (
                  this.isWithinRange(
                    item['start_at'].split(' ')[0],
                    item['end_at'].split(' ')[0],
                    this.chartStartAt,
                    this.chartEndAt
                  )
                ) {
                  return {
                    x: [item['start_at'].split(' ')[0], item['end_at'].split(' ')[0]],
                    y: item['name'],
                    customAnalysisResult: item['analysisResult'],
                  }
                }
              })
              .filter((item) => item !== undefined)
          }

          return item
        })
        // 移除對應實驗狀態沒有資料的項目
        .filter((item) => item.data.length > 0)

      console.log(this.data)

      // 取得所有資料裡面，最小的日期和最大的日期當作defalut值
      // const chartData = [...this.data]

      // let minDate = new Date(chartData[0].data[0].x[0]);
      // let maxDate = new Date(chartData[0].data[0].x[1]);
      // let startDate
      // let endDate
      // chartData.forEach(dataset => {
      //   dataset.data.forEach(item => {
      //     startDate = new Date(item.x[0]);
      //     endDate = new Date(item.x[1]);

      //     if (startDate < minDate) {
      //       minDate = startDate;
      //     }

      //     if (endDate > maxDate) {
      //       maxDate = endDate;
      //     }
      //   });
      // });

      // this.chartStartAt = (this.$utils.parseDateFormat(minDate)).split(' ')[0]
      // this.chartEndAt = (this.$utils.parseDateFormat(maxDate)).split(' ')[0]
    },
    /**
     * 檢查設定的時間是否在使用者指定的時間區間內。
     *
     * @param {string} setStart - 設定的開始日期，格式應該為 "YYYY-MM-DD"。
     * @param {string} setEnd - 設定的結束日期，格式應該為 "YYYY-MM-DD"。
     * @param {string} userStart - 使用者指定的開始日期，格式應該為 "YYYY-MM-DD"。
     * @param {string} userEnd - 使用者指定的結束日期，格式應該為 "YYYY-MM-DD"。
     * @return {boolean} 返回一個布林值，表示設定的時間區間是否在使用者指定的時間區間內。如果設定的時間區間在使用者指定的時間區間之外，則返回 false。
     */
    isWithinRange(setStart, setEnd, userStart, userEnd) {
      setStart = new Date(setStart)
      setEnd = new Date(setEnd)
      userStart = new Date(userStart)
      userEnd = new Date(userEnd)

      // 檢查設定的結束日期是否在使用者的開始日期之前，或設定的開始日期是否在使用者的結束日期之後
      // 如果是，那麼該設定應該被過濾掉
      if (setEnd < userStart || setStart > userEnd) {
        return false
      }

      // 否則，該設定是在使用者指定的時間區間內
      return true
    },
    getDay(days) {
      let theDay = new Date()
      let changeDay = Number(days)
      let timeStamp = theDay.setDate(theDay.getDate() + changeDay)
      return this.$utils.parseDateFormat(timeStamp).split(' ')[0]
    },
    async removeChip(index) {
      console.log(index)
      this.check_rule_chip_items.splice(index, 1)
      if (this.check_rule_chip_items.length > 0) return
      while (this.items_is_match.length) {
        this.items_is_match.pop()
      }
      this.items = await this.getExperiments()
      this.check_rule_mode = false
    },
    openCheckWebRuleDialog() {
      console.log('check')
      console.log(this.items)
      this.check_rule_dialog_setting['fields'][0]['value'] = null
      this.check_rule_dialog_setting['fields'][1]['grids'][0]['value'] = ''
      this.check_rule_dialog_setting['fields'][1]['grids'][1]['value'] = ''
      this.check_rule_dialog_setting['fields'][2]['value'] = false
      this.is_show_check_rule_dialog = true
    },
    checkWebRule(item) {
      console.log('check')
      console.log(item)
      let params = {
        url: item[0]['value'],
        target_time: item[1]['grids'][0]['value'] + ' ' + item[1]['grids'][1]['value'] + ':00',
        container_id: this.$route.params.container_id,
        release_only: item[2]['value'],
      }
      console.log(params)

      // 實驗時間不是必填的欄位，如果使用者沒填會是空的就不要把"target_time"這個欄位送去後端，詳情看http://optimize-staging.isp99.com/api/swagger-ui/index.html#/optimize-controller/getMatchExperience
      if (params['target_time'] === ' ') delete params['target_time']

      apiCheckMatchExperients(this.$route.params.org_id, params)
        .then(async (resp) => {
          params['id'] = Date.now()
          while (this.check_rule_chip_items.length) {
            this.check_rule_chip_items.pop()
          }
          this.check_rule_chip_items.push(params)

          console.log(resp)
          if (resp.data.code === 200) {
            console.log(this.items)
            if (resp.data.data.exp_ids.length > 0) {
              for (let i = 0; i < resp.data.data.exp_ids.length; i++) {
                for (let j = 0; j < this.items.length; j++) {
                  if (resp.data.data.exp_ids[i] === this.items[j]['id']) {
                    this.items[j]['is_match'] = true

                    while (this.items_is_match.length) {
                      this.items_is_match.pop()
                    }

                    this.items_is_match.push(this.items[j])
                    console.log(this.items[j])
                  }
                }
              }
              this.items = JSON.parse(JSON.stringify(this.items))
              console.log(this.items)
              await this.restitutionAboutCheckRule()
            }
            this.check_rule_mode = true
            this.is_show_check_rule_dialog = false
            this.$root.vtoast.show({
              message: '檢查完成，將顯示符合的實驗於資料表中！',
              color: 'primary',
            })
          } else {
            this.$root.vtoast.show({
              message: '檢查失敗，原因: ' + resp.data.msg,
              color: 'error',
            })
          }
        })
        .catch((error) => {
          console.log(error)
          this.$root.vtoast.show({
            message: '檢查失敗，原因: ' + error.response ? error.response : error,
            color: 'error',
          })
        })
    },
    restitutionAboutCheckRule() {
      setTimeout(() => {
        // alert('3秒到了')
        this.items = this.items.map((item) => {
          return { ...item, is_match: false }
        })
        console.log(this.items)
      }, 5000)
    },
    copyExperience: async function (item) {
      console.log('copyyy', item)
      try {
        let params = {
          experience_id: item.id,
        }
        let result = await apiCopyExperience(this.$route.params.org_id, params)
        let id = result.data.experience_id
        console.log('result:', result)
        console.log('id:', id)
        this.$router.push(this.$route.path + id)
      } catch (error) {
        console.log(error)
        let message = '複製實驗失敗，原因:'

        if (error.includes('can only create')) {
          message += '已達實驗數上限，請加購或刪除已經存在的實驗。'
        } else {
          message += error
        }

        this.$root.vtoast.show({
          message: message,
        })
      }
    },
    parentMethod() {
      console.log('Called from deepChild')
    },
    async apiGetNotify() {
      let data
      data = await apiGetNotify(this.$route.params.org_id)
        .then((resp) => {
          console.log(resp)
          return resp.data.data
        })
        .catch((error) => {
          console.log(error)
          return []
        })
      return data
    },
    notify_feature(item) {
      console.log(item)
      console.log(this.notify)
      let open_notify = item.id || false
      if (open_notify) {
        let confirm_dialog = confirm(`確定要開啟 ${item.name} 這個實驗的缺貨提醒嗎？`)

        if (confirm_dialog) {
          console.log('開啟')
        } else {
          item.id = 97
          console.log(item)
          console.log('不開啟')
        }
      } else {
        item.id = 97
        console.log(item)
        console.log('不開啟')
      }
    },
    getExperiments: async function () {
      let that = this
      let data = []
      this.isLoading = true
      try {
        let result = await apiGetExperiments(
          this.$route.params.org_id,
          this.$route.params.container_id,
          this.mode,
          this.page_setting.selected_page,
          this.selected_per_page.value,
          encodeURIComponent(this.search)
        )
        data = result.data.content
        this.page_setting.total_page = result.data.totalPages
        console.log('list: ', data)
      } catch (error) {
        if (error.includes('401') || error.includes('403')) {
          that.$root.vtoast.show({
            message: `沒有權限使用此功能，原因: ${error}`,
          })
          that.$router.push(`/${that.$route.params.org_id}/401`)
        } else {
          that.$root.vtoast.show({
            message: `取得實驗失敗，原因: ${error}`,
          })
        }
      }
      this.isLoading = false
      return data
    },
    showDialog: function () {
      console.log(this.dialog_setting['fields'])
      this.dialog_setting['fields'].map((item) => {
        if (Object.hasOwn(item, 'value') && item.id !== 'url') {
          item.value = null
        }

        if (Object.hasOwn(item, 'grids')) {
          // item.value = null
          item.grids = item.grids.map((grid) => {
            if (Object.hasOwn(grid, 'value')) grid.value = null
            return grid
          })
        }
        return item
      })

      this.is_show_new_dialog = true
    },
    closeDialog: function () {
      this.is_show_check_rule_dialog = false
      this.is_show_new_dialog = false
      this.is_bind_product_by_experience = false
      this.is_open_notify_dialog = false
      this.is_open_update_dialog = false
    },
    addExperiment: async function (fields) {
      console.log(fields)
      let param = {}
      let that = this
      fields.forEach(function (field) {
        param[field.id] = field.value
        // if (field.id === 'start_at'){
        //   param[field.id] = field.value + ' 0:00:00'
        // }
        // if (field.id === 'campaign_start_at' && field.value !== null){
        //   param[field.id] = field.value + ' 0:00:00'
        // }
        // if (field.id === 'end_at'){
        //   param[field.id] = field.value + ' 23:59:59'
        // }
        // if (field.id === 'campaign_end_at' && field.value !== null){
        //   param[field.id] = field.value + ' 23:59:59'
        // }
        if (field.id === 'url') {
          param[field.id] = field.value
          console.log(param[field.id])
        }
        if (
          field.grids !== undefined &&
          field.grids.length === 2 &&
          (field.grids[0]['value'] !== null || field.grids[1]['value'] !== null)
        ) {
          console.log('fieldfield', field)
          let time_end = ':00'
          if (field.grids[0].id.includes('end_at')) {
            time_end = ':59'
          }
          param[that.mapping_backend_field[field.label]] =
            field.grids[0]['value'] + ' ' + (field.grids[1]['value'] + time_end)
        }
      })
      param['container_id'] = this.$route.params.container_id
      console.log(this.$route.params.org_id)

      // 先寫死，目前只有abtest這一個type
      param['target_type'] = 'abtest'

      console.log('此次新增實驗的參數:', param)

      await apiCreateExperiment(param, this.$route.params.org_id)
        .then(async function (resp) {
          //let data = resp.data.data
          console.log(resp)
          if (resp.data.ok === 1) {
            that.$root.vtoast.show({
              message: '新增實驗成功',
              color: 'primary',
            })
            that.closeDialog()
            that.items = await that.getExperiments()
          } else {
            that.$root.vtoast.show({
              message: '新增失敗 : ' + resp.data,
            })
          }
        })
        .catch(function (error) {
          console.error('新增實驗錯誤: ', error)
          if (error.response.status === 401) {
            that.$root.vtoast.show({
              message: `您沒有權限新增實驗！`,
            })
          } else {
            that.$root.vtoast.show({
              message: '新增實驗失敗，原因: ' + error.response ? error.response.data : error,
            })
          }
        })
    },
    async addExperimentV2(setting) {
      console.log('v2', setting)
      let params = {
        target_type: 'abtest',
        container_id: this.$route.params.container_id,
        name: setting.name,
        url: setting.url,
        start_at: `${setting.start_at}:00`,
        end_at: `${setting.end_at}:59`,
        memo: setting.memo ? setting.memo : '',
      }
      params['campaign_start_at'] = params.start_at
      params['campaign_end_at'] = params.end_at

      try {
        let result = await apiCreateExperimentWithData(params, this.$route.params.org_id)
        this.closeDialog()
        this.items = await this.getExperiments()
        await this.getExpQuota()
        this.$root.vtoast.show({
          message: '新增實驗成功',
          color: 'primary',
        })
        setTimeout(() => {
          this.viewInfo(result.data)
        })
      } catch (error) {
        if (error.includes('you can only create')) {
          this.$root.vtoast.show({
            message: `新增實驗失敗，原因: 已達實驗數上限，請加購或刪除已經存在的實驗。`,
          })
        } else {
          this.$root.vtoast.show({
            message: `新增實驗失敗，原因: ${error}`,
          })
        }
      }
    },
    viewInfo: function (item) {
      console.log(this.$route)
      console.log(item)
      item.url = decodeURIComponent(decodeURIComponent(decodeURIComponent(item.url)))
      this.$store.commit('selected_experience', item)
      this.$router.push(this.$route.path + item.id)
    },
    async deleteItem(item) {
      console.log(this.org_id)
      console.log(item)
      let confirm_dialog = confirm(`確定要刪除 ${item.name} 這個實驗嗎？`)
      let is_check = false

      if (confirm_dialog) {
        console.log('刪除')
        await apiDeleteExperiment(item.id, is_check, this.$route.params.org_id)
          .then(async (resp) => {
            console.log(resp)
            this.items = await this.getExperiments()
            await this.getExpQuota()
          })
          .catch((error) => {
            console.log(error)
            if (error.response.status === 401) {
              this.$root.vtoast.show({
                message: `您沒有權限刪除實驗！`,
              })
            } else {
              this.$root.vtoast.show({
                message: '刪除實驗失敗，原因: ' + error.response ? error.response.data : error,
              })
            }
          })
      } else {
        console.log('不刪除')
      }
    },
    bindNotify() {
      // console.log(item);
      console.log(this.get_notify_items)
      let notify_id = this.get_notify_items
        .filter((items) => {
          return items['receiver_name'] === this.receiver_name
        })
        .map((item) => item['id'])
      console.log(notify_id[0])
      let param = { container_id: this.$route.params.container_id, notify_id: notify_id[0] }

      apiPatchNotifyBind(this.$route.params.org_id, param)
        .then((resp) => {
          console.log(resp)
          this.$root.vtoast.show({ message: '缺貨通知綁定成功!', color: 'primary' })
          this.closeDialog()
        })
        .catch((error) => {
          console.log(error)
          this.$root.vtoast.show({ message: '取得管理員失敗，原因: ' + error.response ? error.response.data : error })
        })
    },
    async show_notify_dialog() {
      this.bind_product_dialog_setting['fields'][0].receiver_items = this.get_notify_items.map(
        (item) => item.receiver_name
      )
      this.is_bind_product_by_experience = true
    },
    async releaseExperience(item) {
      let confirm_dialog1 = confirm(`請問您確定要將 ${item.name} 這個實驗發布嗎?   請注意發布後無法再更改此實驗！`)

      if (confirm_dialog1) {
        let confirm_dialog2 = confirm(`請注意發布後無法再更改此實驗！ 您確定要發布實驗嗎?`)

        if (confirm_dialog2) {
          console.log(item)
          await apiPatchExperienceRelease(item.id, this.$route.params.org_id)
            .then((resp) => {
              console.log('發布成功', resp)
              this.$root.vtoast.show({ message: '發布實驗成功!', color: 'primary' })
              this.getExperiments()
              this.tab = 1
            })
            .catch((error) => {
              console.log('發布失敗', error)
              this.$root.vtoast.show({
                message: '發布實驗失敗，原因: ' + error.response ? error.response.data : error,
              })
            })
        } else {
          console.log('不發布')
        }
      } else {
        console.log('不發布')
      }
    },
    async disableExperience(item) {
      console.log(item)
      let confirm_dialog = confirm(`請問您確定要將 ${item.name} 這個實驗結束嗎?   請注意結束後無法再更改此實驗！`)
      if (confirm_dialog) {
        console.log('結束實驗')
        await apiPatchExperienceDisable(item.id, this.$route.params.org_id)
          .then((resp) => {
            console.log('結束實驗成功', resp)
            this.$root.vtoast.show({ message: '結束實驗成功!', color: 'primary' })
            this.getExperiments()
            this.tab = 2
          })
          .catch((error) => {
            console.log('結束實驗失敗', error)
            this.$root.vtoast.show({
              message: '結束實驗失敗，原因: ' + error.response ? error.response.data : error,
            })
          })
      } else {
        console.log('不結束實驗！')
      }
    },
    pares_status(item) {
      let status
      if (item.is_release === true && item.enable === true) {
        status = '發布'
      } else if (item.is_release === false && item.enable === true) {
        status = '草稿'
      } else {
        status = '結束'
      }
      return status
    },
    open_script_dialog() {
      this.isOpenAbtestScript = true
    },
    close_script_dialog() {
      this.isOpenAbtestScript = false
    },
    async copyToClipboard(item, value) {
      // value這個變數的值是從InstallAbTestScriptDialog.vue這個子元件傳來的
      try {
        let textToCopy
        switch (item) {
          case 'head_script':
            if (value !== undefined) {
              textToCopy = value
            } else {
              textToCopy = await this.$refs.head_script.value
            }

            break

          case 'body_script':
            if (value !== undefined) {
              textToCopy = value
            } else {
              textToCopy = await this.$refs.body_script.value
            }

            break

          case 'token':
            textToCopy = await this.$refs.token.value
            break
          case 'line_bot':
            textToCopy = await this.$refs.line_bot.value
            break
          default:
            textToCopy = '未知'
            break
        }
        await navigator.clipboard.writeText(textToCopy)
        console.log('已複製到剪贴板')
        this.snackbar = await true
      } catch (err) {
        console.error('無法複製: ', err)
      }
    },
    async openNotifyDialog(item) {
      console.log(item)
      await this.$store.commit('selected_experience', item)
      this.is_open_notify_dialog = await true
    },
    async registerGroup() {
      let param = { notify_platform: 'line' }
      await apiPatchRegisterGroup(this.$route.params.org_id, param)
        .then((resp) => {
          console.log(resp)
          this.$root.vtoast.show({ message: '註冊群組成功，請打開請打開line bot輸入註冊訊息！', color: 'primary' })
          this.register_group.register_group_token = `Optimize99綁定:${resp.data.data.token}`
          this.register_group.register_group_token_expired = resp.data.data.expired
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handlerTimeFormat(timeString) {
      const date = new Date(timeString)
      date.setHours(date.getHours() + 8)
      const newDate = new Date(date).toISOString().split('T')[0] + ' ' + new Date(date).toTimeString().split(' ')[0]
      return newDate
    },
    async getUsedQuantity(tab_idx) {
      console.log('tab_idx', tab_idx)
      let quantity = 0
      let limit = 0
      try {
        let tmp_start_at = this.$utils
          .getYYYYMMDDHHMMSS(this.$utils.calculateDate(-30).toISOString(), '-')
          .split(' ')[0]
        let tmp_end_at = this.$utils.getYYYYMMDDHHMMSS(this.$utils.calculateDate(30).toISOString(), '-').split(' ')[0]
        let result = await apiGetSubscriptionInfoWithData(this.$route.params.org_id, tmp_start_at, tmp_end_at)
        console.log('用量: ', result)

        if (tab_idx === 'release') {
          let limit_usage = result.quotaVo.filter(function (quota) {
            return quota.function === 'ReleaseExperienceRemaining'
          })
          console.log('limit_usage', limit_usage)
          limit = limit_usage[0].limit

          let today = this.$utils.getYYYYMMDDHHMMSS(null, '-')
          let now_day = today.split(' ')[0]
          let day_usage = result.duration_usage.filter(function (usage) {
            return usage.date.includes(now_day) === true
          })
          if (day_usage.length !== 0) {
            quantity = day_usage[0].exp_cnt
          }
        }

        if (tab_idx === 'end') {
          let function_usage = result.usage.filter(function (function_usage) {
            return function_usage.function === 'HistoryExperienceRemaining'
          })
          console.log('function_usage', function_usage)
          if (function_usage[0]) {
            quantity = function_usage[0].usage
          } else {
            quantity = 0
          }

          let limit_usage = result.quotaVo.filter(function (quota) {
            return quota.function === 'HistoryExperienceRemaining'
          })
          if (limit_usage[0]) {
            limit = limit_usage[0].limit
            if (limit_usage[0].addon) {
              limit += limit_usage[0].addon
            }
          }
        }
      } catch (error) {
        console.log(error)
        this.$root.vtoast.show({
          message: '取得用量失敗，原因: ' + JSON.stringify(error.response ? error.response.data : error),
        })
      }

      return { quantity, limit }
    },
    async getExpQuota() {
      this.quota_setting.is_show = false
      let { quantity, limit } = await this.getUsedQuantity('end')
      console.log('quantity', quantity)
      console.log('limit', limit)
      this.quota_setting.quantity = quantity
      this.quota_setting.limit = limit
      this.quota_setting.display_name = this.quota_setting.name['end']
      this.quota_setting.is_show = true
    },
    async changeTab(tab_item) {
      console.log('now_tab', tab_item)
      const currentRoute = this.$route
      const currentQuery = Object.assign({}, currentRoute.query)
      currentQuery.mode = this.tab_mapper[tab_item.index]
      currentQuery.page = 1
      currentQuery.keyword = ''
      this.search = ''
      this.page_setting.selected_page = 1
      this.page_setting.is_show = false
      await this.$router.replace({ query: currentQuery })
      this.mode = this.tab_mapper[tab_item.index]
      this.items = await this.getExperiments()
      this.page_setting.is_show = true
    },
    chagePerPage: async function (selected_per_page) {
      this.loading = true
      let query = this.$route.query
      let tmp_query = { ...query, limit: selected_per_page.value, page: 1 }
      console.log(tmp_query)
      try {
        await this.$router.replace({ path: this.$route.path, query: tmp_query })
      } catch (err) {
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      }
      this.items = await this.getExperiments()
      this.loading = false
    },
    openURL(item) {
      console.log('item:', item)
      let url = decodeURIComponent(decodeURIComponent(item.url))
      if (url.indexOf('https://') === -1) {
        url = `https://${url}`
      }
      console.log('url:', url)
      window.open(url, '_blank')
    },
    async changePageCallback(page) {
      this.loading = true
      console.log('changePage', page)
      this.page_setting.selected_page = page
      this.items = await this.getExperiments()
      this.loading = false
    },
    async searchKeyword(keyword) {
      console.log('keyword:', keyword)
      let query = this.$route.query
      let tmp_query = { ...query, limit: this.selected_per_page.value, page: 1, keyword: keyword, mode: this.mode }
      console.log(tmp_query)
      this.loading = true
      try {
        await this.$router.replace({ path: this.$route.path, query: tmp_query })
        this.items = await this.getExperiments()
      } catch (err) {
        this.loading = false
        console.log('ex')
        console.log('err.name', err.name)
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      }
      this.loading = false
    },
    getExpURL(id) {
      return `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/experiments/${id}`
    },
  },
}
</script>
<style scoped>
h4 {
  color: #5b5b5b;
}

.btn-danger {
  background: #e3262e;
  background-image: linear-gradient(180deg, #e3262e, #ab171e);
  color: #fff;
  border: 1px solid #ab171e;
  text-decoration: none;
  min-width: 40px;
  box-shadow: inset 0 1px 1px #ff7b81, 0 2px 2px -1px rgba(0, 0, 0, 0.2);
}

.truncate {
  margin: 0;
  padding: 0;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pointer {
  cursor: pointer;
}

.v-breadcrumbs__item--disabled {
  color: rgba(0, 0, 0, 0.38) !important;
}

.scrolling-input input {
  overflow-x: auto;
  white-space: nowrap;
}

.multi-line-chip {
  white-space: pre-line;
}
.row-pointer {
  cursor: pointer;
  color: #1a73e8;
}
.row-pointer:hover {
  color: #174ea6;
  text-decoration: underline;
}
</style>
